module.exports = __webpack_public_path__ + "img/thumb_27.17cae268.jpg";